import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const DataPoints = () => {
  const dataPoints = useSelector((state) => state.freezeLifecycle.chartsData.data_points);
  const { qa } = useSelector((state) => state.commonReducer.commonProps);

  if (!dataPoints || !dataPoints.length) return null;

  // Currently Frozen has 2 data points (single column); Freeze History has 4 and needs the
  // 2x2 grid layout instead — see freezeLifecycle.scss's ".data-points--grid".
  const className = dataPoints.length > 2 ? "data-points data-points--grid" : "data-points";

  return (
    <div className={className}>
      {dataPoints.map(({ label, value, type, url, tooltip }) => (
        <div key={label} className="data-point">
          <DataDisplay
            disableAnimation={qa}
            label={label}
            value={value}
            type={type}
            url={url}
            toolTipContent={tooltip}
          />
        </div>
      ))}
    </div>
  );
};

export default DataPoints;
